import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap, catchError, Observable, of, throwError } from 'rxjs';
import { ClientDetails } from 'src/app/models/client-details';
import { ClientDocs } from 'src/app/models/client-docs';
import { ClientEmployments } from 'src/app/models/client-employments';
import { ClientRelations } from 'src/app/models/client-relations';
import { ShareService } from 'src/app/shared/services/share-service';
import { ClientBeneficiaryDataModel, ClientBeneficiaryFormModel, LoanPaymentDataModel, LoanPaymentFormModel, SendPaymentDataModel, SendPaymentFormModel } from './account-models';
import { ApiResponseData } from 'src/app/models/global-model';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private apiUrl: string;
  // private accountUrl:string;
  private loanRepaymentUrl:string;
  private walletTransferUrl:string;
  private walletVerificationUrl:string;
  private bankTransferUrl:string;
  private momoTransferUrl:string;
  private clientBeneficiaryUrl:string;

  cfg: any;
  clientDashboardUrl: string;

  constructor(private http: HttpClient, private shareService: ShareService) {
      this.cfg = this.shareService.getConfig();
      this.apiUrl = this.cfg.apiBaseUrl;

      this.loanRepaymentUrl = this.apiUrl + this.cfg.products.loan.repayloan;
      this.clientBeneficiaryUrl = this.apiUrl + this.cfg.client.beneficiary;

      this.clientDashboardUrl = this.apiUrl + this.cfg.client.dashboard;

      this.walletTransferUrl = this.apiUrl + this.cfg.wallet.transfer.wallet;
      this.walletVerificationUrl = this.apiUrl + this.cfg.wallet.verifyAccountNumber;
      this.bankTransferUrl = this.apiUrl + this.cfg.wallet.transfer.bank;
      this.momoTransferUrl = this.apiUrl + this.cfg.wallet.transfer.momo;

    }

  
    addClient(details: ClientDetails) {
      // console.table(details);
      var url = this.apiUrl + this.cfg.client.client;
      // console.log("URL " + url);
      return this.http.post(url, details)
        .pipe(
          tap((response: any) => {
            console.table(response);
  
            return 1;
          }), catchError(
            (error: HttpErrorResponse): Observable<any> => {
              // we expect 404, it's not a failure for us.
              if (error.status === 404) {
                return of(null); // or any other stream like of('') etc.
              }
  
              // other errors we don't know how to handle and throw them further.
              return throwError(() => error);
            },
          )
        )
    }

    updateClient(details: ClientDetails) {
      // console.table(details);
      var url = this.apiUrl + this.cfg.client.client+"/"+details.id;
      // console.log("URL " + url);
      return this.http.put(url, details)
        .pipe(
          tap((response: any) => {
            // console.table(response);
  
            return 1;
          }), catchError(
            (error: HttpErrorResponse): Observable<any> => {
              // we expect 404, it's not a failure for us.
              if (error.status === 404) {
                return of(null); // or any other stream like of('') etc.
              }
  
              // other errors we don't know how to handle and throw them further.
              return throwError(() => error);
            },
          )
        )
    }
    
  
    getClientProfile() {
      // console.log("getClientProfile called");
      var url = this.apiUrl + this.cfg.client.profile;
      let profile = new Promise(resolve => {
        this.http.get<any>(url).subscribe(res => {
          // console.log(res["data"]);
          resolve(res["data"]);
        })
      });
      return profile;
    }
  
    saveClientRelation(cr: ClientRelations) {
      // console.log("relation data "+JSON.stringify(cr));
      var url = this.apiUrl + this.cfg.client.relation;
      
      let relation = new Promise(resolve => {
        if(cr.id != null){
          url = url+"/"+cr.id;
          this.http.patch<any>(url, cr).subscribe(res => {
          resolve(res);
        })
        }
        else{
          this.http.post<any>(url, cr).subscribe(res => {
            resolve(res);
          })
        }
        // resolve(1);
        // console.log("client relation url "+url)
      })
  
      return relation;
    }
  
    getClientRelation(id: number) {
      var url = this.apiUrl + this.cfg.client.relation+"/"+id;
      // console.log("get client relation url "+url)
      let relation = new Promise(resolve => {
        this.http.get<any>(url).subscribe(res => {
          resolve(res);
        })
      })
  
      return relation;
    }
  
    deleteClientRelation(id:number){
      var url = this.apiUrl + this.cfg.client.relation+"/"+id;
      let relation = new Promise(resolve=>{
        this.http.delete(url).subscribe(res=>{
          resolve(res);
        })
      })
  
      return relation;
    }
  
    saveClientDocument(cd: ClientDocs) {
      console.log("docs data "+JSON.stringify(cd));
      var url = this.apiUrl + this.cfg.client.docs;
      
      console.log("url for save client doc "+url);
  
      let promise = new Promise(resolve => {
        if(cd.id != null){
          url = url+"/"+cd.id;
          this.http.patch<any>(url, cd).subscribe(res => {
          resolve(res);
        })
        }
        else{
          this.http.post<any>(url, cd).subscribe(res => {
            resolve(res);
          })
        }
      })
  
      return promise;
    }
  
    getClientDocument(id: number) {
      var url = this.apiUrl + this.cfg.client.docs+"/"+id;
      // console.log("get client relation url "+url)
      let promise = new Promise(resolve => {
        this.http.get<any>(url).subscribe(res => {
          resolve(res);
        })
      })
  
      return promise;
    }
  
    deleteClientDocument(id:number){
      var url = this.apiUrl + this.cfg.client.docs+"/"+id;
      let promise = new Promise(resolve=>{
        this.http.delete(url).subscribe(res=>{
          resolve(res);
        })
      })
  
      return promise;
    }
  
    saveClientEmployment(ce: ClientEmployments) {
      // console.log("relation data "+JSON.stringify(ce));
      var url = this.apiUrl + this.cfg.client.employment;
      
      // console.log("url for save employment "+url);
  
      let employment = new Promise(resolve => {
        if(ce.id != null){
          url = url+"/"+ce.id;
          this.http.patch<any>(url, ce).subscribe(res => {
          resolve(res);
        })
        }
        else{
          this.http.post<any>(url, ce).subscribe(res => {
            resolve(res);
          })
        }
        // resolve(1);
        // console.log("client relation url "+url)
      })
  
      return employment;
    }
  
    getClientEmployment(id: number) {
      var url = this.apiUrl + this.cfg.client.employment+"/"+id;
      // console.log("get client relation url "+url)
      let employment = new Promise(resolve => {
        this.http.get<any>(url).subscribe(res => {
          resolve(res);
        })
      })
  
      return employment;
    }
  
    deleteClientEmployment(id:number){
      var url = this.apiUrl + this.cfg.client.employment+"/"+id;
      let relation = new Promise(resolve=>{
        this.http.delete(url).subscribe(res=>{
          resolve(res);
        })
      })
  
      return relation;
    }
  
    getRelationTypesDll() {
      // var relTypes = [
      //   { "id": "", "name": "--Select--" },
      //   { "id": "brother", "name": "Brother" },
      //   { "id": "sister", "name": "Sister" },
      //   { "id": "son", "name": "Son" },
      //   { "id": "daughter", "name": "Daughter" },
      //   { "id": "spouse", "name": "Spouse" },
      //   { "id": "mother", "name": "Mother" },
      //   { "id": "fatther", "name": "Father" },
      // ]
      // return relTypes;
      var url = this.apiUrl + this.cfg.admin.lookups+"/Relation";
      // console.log("lookups url "+url);
      let promise = new Promise(resolve => {
        this.http.get<any>(url).subscribe(res => {
          resolve(res["data"]);
        })
      });
      return promise;
    }
    getMaritalStatusDll() {
      // var statuses = [
      //   { "id": "", "name": "--Select--" },
      //   { "id": "single", "name": "Single" },
      //   { "id": "married", "name": "Married" },
      //   { "id": "divorced", "name": "Divorced" }
      // ]
      // return statuses;
      var url = this.apiUrl + this.cfg.admin.lookups+"/Marital Status";
      // console.log("lookups url "+url);
      let promise = new Promise(resolve => {
        this.http.get<any>(url).subscribe(res => {
          resolve(res["data"]);
        })
      });
      return promise;
    }
    getGenderDll() {
      // var genders = [
      //   { "id": "", "name": "--Select--" },
      //   { "id": "male", "name": "Male" },
      //   { "id": "female", "name": "Female" }
      // ]
      // return genders;
      var url = this.apiUrl + this.cfg.admin.lookups+"/Gender";
      console.log("lookups url "+url);
      let promise = new Promise(resolve => {
        this.http.get<any>(url).subscribe(res => {
          resolve(res["data"]);
        })
      });
      return promise;
    }
    getEmploymentTypesDll() {
      // var types = [
      //   { "id": "", "name": "--Select--" },
      //   { "id": "unemployed", "name": "Unemployed" },
      //   { "id": "selfemployed", "name": "Self Employed" },
      //   { "id": "privatesector", "name": "Private Sector Employed" },
      //   { "id": "publicsector", "name": "Public Sector Employed" },
      // ]
      // return types;
      var url = this.apiUrl + this.cfg.admin.lookups+"/Employment Types";
      // console.log("lookups url "+url);
      let promise = new Promise(resolve => {
        this.http.get<any>(url).subscribe(res => {
          resolve(res["data"]);
        })
      });
      return promise;
    }
  
    getDocTypesDll() {
      // var types = [
      //   { "id": "", "name": "--Select--" },
      //   { "id": "offerletter", "name": "Offer Letter" },
      //   { "id": "businessregistration", "name": "Business Registration" }
      // ]
      // return types;

      var url = this.apiUrl + this.cfg.admin.lookups+"/Document Types";
      // console.log("lookups url "+url);
      let promise = new Promise(resolve => {
        this.http.get<any>(url).subscribe(res => {
          resolve(res["data"]);
        })
      });
      return promise;
    }

    getGenericLookup(category:string){
      var url = this.apiUrl + this.cfg.admin.lookups+"/"+category;
      // console.log("lookups url "+url);
      let promise = new Promise(resolve => {
        this.http.get<any>(url).subscribe(res => {
          resolve(res["data"]);
        })
      });
      return promise;
    }
    
  
    getEmployers(){
      var url = this.apiUrl + this.cfg.client.employer;
      // console.log("employers url "+url);
      let promise = new Promise(resolve => {
        this.http.get<any>(url).subscribe(res => {
          resolve(res["data"]);
        })
      });
      return promise;
    }
  
    getClients(){
      var url = this.apiUrl + this.cfg.client.client;
  
      // console.log("clients url "+url);
      let promise = new Promise(resolve =>{
        this.http.get<any>(url).subscribe(res => {
          resolve(res["data"]);
        })
      })
      return promise;
    }

    getWallet(){
      var url = this.apiUrl + this.cfg.wallet.mywallet;
  
      console.log("my wallet url "+url);
      let promise = new Promise(resolve =>{
        this.http.get<any>(url).subscribe(res => {
          resolve(res);
        })
      })
      return promise;
    }

    myLoansLookup(){
      var url = this.apiUrl + this.cfg.products.loan.loanlookup;
  
      console.log("my loans lookup url "+url);
      let promise = new Promise(resolve =>{
        this.http.get<any>(url).subscribe(res => {
          resolve(res);
        })
      })
      return promise;
    }

    myBeneficiariesLookup(){
      var url = this.apiUrl + this.cfg.client.beneficiarylookup;
  
      console.log("my beneficiaires lookup url "+url);
      let promise = new Promise(resolve =>{
        this.http.get<any>(url).subscribe(res => {
          resolve(res);
        })
      })
      return promise;
    }

    getDashboard(){
      var url = this.apiUrl + this.cfg.wallet.dashboard;
      console.log("dashboard url "+url);
      let promise = new Promise(resolve => {
        this.http.get<any>(url).subscribe(res => {
          resolve(res["data"]);
        })
      });
      return promise;
    }


    createBeneficiary(dataForm: Partial<ClientBeneficiaryFormModel>) {
      const data: Partial<ClientBeneficiaryDataModel> = {
          is_cb:dataForm.inputIsCB,
          cb_wallet_id: dataForm.inputCbWalletId,
          is_bank:dataForm.inputIsBank,
          bank_id:dataForm.inputBankId,
          is_momo:dataForm.inputIsMomo,
          momo_type_id:dataForm.inputMomoTypeId,
          beneficiary_name:dataForm.inputBeneficiaryName,
          account_number:dataForm.inputAccountNumber,
          active_flag:dataForm.inputIsEnabled ? 1:0 
      };
      // console.log("url "+this.clientBeneficiaryUrl+" "+JSON.stringify(data));
      return this.http
          .post<ClientBeneficiaryDataModel>(
              this.clientBeneficiaryUrl,
              data
          ).pipe(
              catchError(this.handleError)
          );
  }

    updateBeneficiary(dataForm: Partial<ClientBeneficiaryFormModel>) {
      const data: Partial<ClientBeneficiaryDataModel> = {
          // id:dataForm.inputId,
          is_cb:dataForm.inputIsCB,
          cb_wallet_id: dataForm.inputCbWalletId,
          is_bank:dataForm.inputIsBank,
          bank_id:dataForm.inputBankId,
          is_momo:dataForm.inputIsMomo,
          momo_type_id:dataForm.inputMomoTypeId,
          beneficiary_name:dataForm.inputBeneficiaryName,
          account_number:dataForm.inputAccountNumber,
          active_flag:dataForm.inputIsEnabled ? 1:0 
      };
      // console.log("url "+this.clientBeneficiaryUrl+" "+JSON.stringify(data));
      return this.http
          .post<ClientBeneficiaryDataModel>(
              this.clientBeneficiaryUrl,
              data
          ).pipe(
              catchError(this.handleError)
          );
  }

    verifyAccountNumber(dataForm) {
      // console.log("url "+this.walletVerificationUrl+" "+JSON.stringify(dataForm));
      return this.http
          .post<ClientBeneficiaryDataModel>(
              this.walletVerificationUrl,
              dataForm
          ).pipe(
              catchError(this.handleError)
          );
  }

  updateLoan(dataForm: Partial<ClientBeneficiaryFormModel>) {
    const data: Partial<ClientBeneficiaryDataModel> = {
      is_cb:dataForm.inputIsCB,
      cb_wallet_id: dataForm.inputCbWalletId,
      is_bank:dataForm.inputIsBank,
      bank_id:dataForm.inputBankId,
      is_momo:dataForm.inputIsMomo,
      momo_type_id:dataForm.inputMomoTypeId,
      beneficiary_name:dataForm.inputBeneficiaryName,
      account_number:dataForm.inputAccountNumber,
      active_flag :dataForm.inputIsEnabled === true ? 1:0
  };
  // console.log("url "+this.clientBeneficiaryUrl+" "+JSON.stringify(data));
      return this.http
          .put<ClientBeneficiaryDataModel>(
              this.clientBeneficiaryUrl,
              data
          ).pipe(
              catchError(this.handleError)
          );
  }

  getBeneficiaries(recordsPerPage: number, pageNumber: number, searchText: string) {
      // alert("was called" +this.loanUrl);
      let searchWord = searchText;
      if (searchWord?.trim().length <= 0) {
          searchWord = '%';
      }
      let searchParams = new HttpParams();
      searchParams = searchParams.append('page', pageNumber);
      searchParams = searchParams.append('search_text', searchWord);
      searchParams = searchParams.append('records_per_page', recordsPerPage);
      return this.http
          .get<ApiResponseData>(
              this.clientBeneficiaryUrl,
              {
                  params: searchParams
              }
          ).pipe(
              catchError(this.handleError)
          );
  }

  deleteLoan(id: number) {
      let deleteParams = new HttpParams();
      deleteParams = deleteParams.append('id', id);
      return this.http.delete<ClientBeneficiaryDataModel>(
          this.clientBeneficiaryUrl,
          {
              params: deleteParams
          }
      ).pipe(
          catchError(this.handleError)
      );
  }

    makePayment(paymentForm: Partial<LoanPaymentFormModel>) {
      const loanData: Partial<LoanPaymentDataModel> = {
          loan_id: paymentForm.inputLoanId,
          payment_amount:paymentForm.inputPaymentAmount,
          payment_source: paymentForm.inputPayFrom
      };
      // var url = this.loanUrl+this.cfg.loan.loanrepay
      console.log("repayment url "+this.loanRepaymentUrl+" "+JSON.stringify(loanData));
      return this.http
          .post<LoanPaymentDataModel>(
              this.loanRepaymentUrl,
              loanData
          ).pipe(
              catchError(this.handleError)
          );
  }

    withdrawMoney(paymentForm: Partial<LoanPaymentFormModel>) {
      const loanData: Partial<LoanPaymentDataModel> = {
          loan_id: paymentForm.inputLoanId,
          payment_amount:paymentForm.inputPaymentAmount,
          payment_source: paymentForm.inputPayFrom
      };
      // var url = this.loanUrl+this.cfg.loan.loanrepay
      console.log("repayment url "+this.loanRepaymentUrl+" "+JSON.stringify(loanData));
      return this.http
          .post<LoanPaymentDataModel>(
              this.loanRepaymentUrl,
              loanData
          ).pipe(
              catchError(this.handleError)
          );
  }
    sendMoney(paymentForm: Partial<SendPaymentFormModel>) {
      const data: Partial<SendPaymentDataModel> = {
          send_id: paymentForm.inputSendId,
          beneficiary_id:paymentForm.inputReceipient,
          payment_amount:paymentForm.inputAmount,
          payment_to: paymentForm.inputPayTo
      };
      // var url = this.loanUrl+this.cfg.loan.loanrepay
      console.log("wallet transfer url "+this.walletTransferUrl+" "+JSON.stringify(data));
      return this.http
          .post<SendPaymentDataModel>(
              this.walletTransferUrl,
              data
          ).pipe(
              catchError(this.handleError)
          );
  }

   getClientDashboard(){
        let searchParams = new HttpParams();
         return this.http
                    .get<ApiResponseData>(
                        this.clientDashboardUrl,
                        {
                            params: searchParams
                        }
                    ).pipe(
                        catchError(this.handleError)
                    );
            }

  private handleError(errorRes: HttpErrorResponse) {
    let errorMessage = 'An unknown error occurred!';
    if (!errorRes.error) {
        return throwError(errorMessage);
    }
    errorMessage = errorRes.error;
    return throwError(errorMessage);
}
}
